/// <amd-module name="Test/TestPlansLibrary/LibraryHub/Redux/TestPlansLibraryContracts" />
import * as Contracts from "TestPlanCommon/Contracts/TestPlan";

/**
 * ITestPlansLibraryAwareState: This state contains global information for the test plans library
 * All pivot specific states extend from this 'global' state.
 */
export interface ITestPlansLibraryAwareState {
    testPlansLibraryState: ITestPlansLibraryState;
}

export interface ITestPlansLibraryState {}

export interface IUserIdentity {
    displayName: string;
    id: string;
}

export interface IWorkItemPageOptions {
    navigationButtonTitle: string;
    headerTitle: string;
    workItemType?: string;
    routeId: string;
    workItemId?: string;
}

/**
 * ITestPlansLibraryLocalContext: Contract for the react.context object that we use to store data that doesn't belong in redux store.
 * How do you decide what data to store in the context:
 * - When putting it in the redux store does not make sense. Changing of data doesn't really require you to re-render the components
 * - When you want to access same data across various components/bundles without using prop drilling
 * - Use this to store transient and mutable data
 */
export interface ITestPlansLibraryLocalContext {
    /**
     * _currentSelectedPivot: This stores the value of the currently selected pivot.
     * This might be useful in cases where a function needs to be performed only in a specific tab
     */
    _currentSelectedPivot: string | undefined;
    getCurrentPivot(): string | undefined;
    setCurrentPivot(val: string): void;

    /**
     * _isPageLoad: This will be true while is page loading and after one of the pivots has been loaded, it will be set to false.
     * This is used in logging page load TTI telemetry data correctly.
     */
    _isPageLoad: boolean;
    isPageLoad(): boolean;
    setPageLoad(value: boolean): void;
}

/**
 * Interface used to hold data provider-specific contents in state. This is used when the data provider deals with work items
 * e.g. Test Cases, Shared Steps etc.
 */
export interface ILibraryWorkItemDataProviderState {
    /**
     * Currently selected query in filter
     */
    queryType: string;

    /**
     * List of filter values to supply to data provider
     */
    filterValues?: Contracts.TestPlansLibraryWorkItemFilter[];

    /**
     * Saved continuationToken used to fetch next page from data provider
     */
    continuationToken?: string;

    /**
     * Indicating there are more elements to be fetched from server
     */
    hasMoreElements: boolean;

    /**
     * List of column options
     */
    columnOptions?: string[];
}
